module.exports = __webpack_public_path__ + "img/icon-arrow-left-circle.bffb7394.svg";